export default __webpack_public_path__ + "static/media/eye-of-sauron.3db113b0.png";